import { Card, Col, Form, Input, Modal, Row, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { forwardRef, useImperativeHandle, useState } from "react";
import { hostname } from "../hooks/useEndeavour";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
const UpdatePassword = forwardRef((props, ref) => {
  const [form] = useForm();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const updatePassword = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/user/update-password`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            message.success("Update Password!");
            close();
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err.status === 400) {
            message.error(err.response.data.payload[0]);
          }
        });
    },
  });

  const show = () => {
    setOpen(true);
  };
  const close = () => {
    form.resetFields();
    setOpen(false);
  };
  useImperativeHandle(
    ref,
    () => ({
      show,
      close,
    }),
    []
  );

  const onFinish = () => {
    form
      .validateFields()
      .then((values) => {
        updatePassword.mutate(values);
      })
      .catch((error) => {});
  };

  return (
    <Modal open={open} title={"Update Password"} onCancel={close} okText="Update Password" onOk={onFinish}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Form layout="vertical" onFinish={onFinish} form={form}>
              <Form.Item
                label="Password"
                name={"password"}
                rules={[
                  { required: true, message: "Please input password!" },
                  { min: 6, message: "Password must be at least 6 characters long!" },
                ]}
              >
                <Input.Password autoFocus />
              </Form.Item>
              <Form.Item
                label="New Password"
                name={"new_password"}
                rules={[
                  { required: true, message: "Please input new password!" },
                  { min: 6, message: "Password must be at least 6 characters long!" },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="One Time Password"
                name={"otp"}
                rules={[
                  { required: true, message: "Please input otp code!" },
                  { min: 6, message: "Password must be at least 6 characters long!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Modal>
  );
});

export default UpdatePassword;
